import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInverterPerformanceChartSkeleton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 711,
	height: 308,
	viewBox: "0 0 711 308",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M46 9L687 8.99994",
			stroke: "#EDEDED",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206 283L206 9",
			stroke: "#EDEDED",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M368 283L368 9",
			stroke: "#EDEDED",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M529 284L529 9.00001",
			stroke: "#EDEDED",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M686.75 283L686.75 19",
			stroke: "#EDEDED",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46 76L687 75.9999",
			stroke: "#EDEDED",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46 143L687 143",
			stroke: "#EDEDED",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46 210L687 210",
			stroke: "#EDEDED",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 140.892C0 137.086 3.08562 134 6.89193 134H34.1081C37.9144 134 41 137.086 41 140.892V146.108C41 149.914 37.9144 153 34.1081 153H6.89193C3.08562 153 0 149.914 0 146.108V140.892Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 6.89193C0 3.08562 3.08562 0 6.89193 0H34.1081C37.9144 0 41 3.08562 41 6.89193V12.1081C41 15.9144 37.9144 19 34.1081 19H6.89193C3.08562 19 0 15.9144 0 12.1081V6.89193Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47 9L47 284",
			stroke: "#EDEDED",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M687 284L47 284",
			stroke: "#EDEDED",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 295.892C32 292.086 35.0856 289 38.8919 289H66.1081C69.9144 289 73 292.086 73 295.892V301.108C73 304.914 69.9144 308 66.1081 308H38.8919C35.0856 308 32 304.914 32 301.108V295.892Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185 295.892C185 292.086 188.086 289 191.892 289H219.108C222.914 289 226 292.086 226 295.892V301.108C226 304.914 222.914 308 219.108 308H191.892C188.086 308 185 304.914 185 301.108V295.892Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M343 295.892C343 292.086 346.086 289 349.892 289H377.108C380.914 289 384 292.086 384 295.892V301.108C384 304.914 380.914 308 377.108 308H349.892C346.086 308 343 304.914 343 301.108V295.892Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M506 295.892C506 292.086 509.086 289 512.892 289H540.108C543.914 289 547 292.086 547 295.892V301.108C547 304.914 543.914 308 540.108 308H512.892C509.086 308 506 304.914 506 301.108V295.892Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M670 295.892C670 292.086 673.086 289 676.892 289H704.108C707.914 289 711 292.086 711 295.892V301.108C711 304.914 707.914 308 704.108 308H676.892C673.086 308 670 304.914 670 301.108V295.892Z",
			fill: "#EEEEEE"
		})
	]
});
export default SvgInverterPerformanceChartSkeleton;
